import { useTranslation } from '../../i18n/LanguageContext'
import { SwordIcon } from './SwordIcon'
import './HeroAuth.css'

const HeroAuth = ({ user, onAuthClick, onAccountClick }) => {
  const { t } = useTranslation()
  return (
    <div className="hero__auth">
      {user ? (
        <button className="hero__user-btn" onClick={onAccountClick} title={t('hero.viewAccount')}>
          <SwordIcon isLoggedIn={true} size={32} />
          <span className="hero__username">{user.nickname || user.username}</span>
        </button>
      ) : (
        <button className="hero__login-btn" onClick={onAuthClick} title={t('hero.loginRegister')}>
          <SwordIcon isLoggedIn={false} size={32} />
          <span className="hero__login-text">{t('hero.loginRegister')}</span>
        </button>
      )}
    </div>
  )
}

export default HeroAuth
